import { useQuery } from "@tanstack/react-query";
import { QuestionnaireApi } from "../questionnaire.api";
import { questionnaireKeys } from "./questionnaire.keys";

export const useQuestionnaireInstancesQuery = (
  contextType?: string,
  contextId?: string
) => {
  return useQuery({
    queryKey: questionnaireKeys.instances(contextType ?? "", contextId ?? ""),
    queryFn: () => QuestionnaireApi.getInstances(contextType!, contextId!),
    enabled: Boolean(contextType && contextId),
    staleTime: 30_000,
  });
};
